/**
 * Map from `/data/<entity>` slug → canonical action(s) that the
 * row-click modal dispatches. Single source of truth on the
 * dashboard side; future `update_*` phases add their own entries
 * here — no catalog / registry change required, the field on the
 * action's registry entry (`dashboardSurface: 'data-row-edit'`)
 * declares the intent and the map declares the wire-up.
 *
 * Phase 14 shipped exactly one entry: `members → 'update_member'`.
 *
 * Phase 38 widens the value type from `string` to
 * `string | string[]` so an entity can surface MULTIPLE actions on
 * the same row (each rendered as a button in the modal). First
 * consumer: `payments → ['reconcile_orphan_payment', 'unlink_payment']`.
 * Per-row conditional surfacing (e.g. only show `unlink_payment`
 * when `member_id` is non-null) is implemented inside `Data.tsx`
 * — the map only declares which actions COULD apply.
 *
 * Entities WITHOUT an entry render rows that are not interactive
 * (no click handler, no hover hint).
 */

export const ENTITY_UPDATE_ACTIONS: Record<string, string | string[] | undefined> = {
  members: "update_member",
  // Phase 38 — reconcile + unlink. Both surface on /data/payments
  // row-modal; per-row conditional visibility implemented inside the
  // modal (reconcile defaults to visible when member_id IS NULL;
  // unlink shown when member_id is non-null).
  payments: ["reconcile_orphan_payment", "unlink_payment"],
  // Phase 57 — per-person memory hand-edit. Clicking a /data/member_memory
  // (or /data/trainer_memory) row opens the edit modal for the two
  // human-authored fields (claude_md / summary_md). rolling_md / longterm_md
  // are cron-owned (phase 58) and not editable here.
  member_memory: "update_member_memory",
  trainer_memory: "update_trainer_memory",
  // Trainer row edit — display_name / phone / send_post_session_message /
  // metadata (the per-trainer T3 post-session capture toggle + contact fields).
  trainers: "update_trainer",
};
